/**
 * Formats a monetary amount using the browser's Intl formatter, falling back to
 * a plain fixed-decimal string for unknown currency codes.
 *
 * @param {number} amount - The amount to format.
 * @param {string} currencyCode - An ISO currency code (e.g. CAD).
 * @returns {string} The formatted currency string.
 */
const formatCurrency = (amount: number, currencyCode: string): string => {
  const safeAmount = Number.isFinite(amount) ? amount : 0

  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: currencyCode || 'CAD',
    }).format(safeAmount)
  } catch {
    return `${safeAmount.toFixed(2)} ${currencyCode}`
  }
}

export { formatCurrency }
